import { Cell } from '@table-library/react-table-library/table';
import Sparkline from '../../../components/Sparklines';
import numeral from 'numeral';
import { collectCell } from '../../../helpers/showPriorData';

export const COLUMNS = (t) => [
    {
        label: t('search.custom_keywords.columns.keyword'),
        key: 'keyword',
        data: 'keyword',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <strong>
                    <a
                        href={`/domains/${
                            window.info.id
                        }/gsc-reports/keywords/keyword?keyword=${encodeURIComponent(data)}`}
                        className="d-inline-flex align-items-center justify-content-center"
                        rel="noreferrer"
                    >
                        {data}
                    </a>
                </strong>
            );
        },
    },
    {
        label: t('search.custom_keywords.columns.firstSeenLastSeen'),
        key: 'seen',
        data: 'seen',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return `${item.firstSeen.value} -> ${item.firstSeen.value}`;

            return (
                <div>
                    <strong>{item.firstSeen.value}</strong>
                    <div className="delta-number">{item.lastSeen.value}</div>
                </div>
            );
        },
    },
    {
        label: t('search.custom_keywords.columns.maxClicks'),
        key: 'maxClicks',
        data: 'maxClicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.custom_keywords.columns.clicks'),
        key: 'avgClicks',
        data: 'avgClicks',
        Component: Cell,
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;
            return collectCell(data, item.clicksL);
        },
    },
    {
        label: t('search.custom_keywords.columns.trend'),
        key: 'sparkline',
        data: 'sparkline',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return '-';
            return <Sparkline dataL={item.clicksL} keyName="Clicks" />;
        },
    },
    {
        label: t('search.custom_keywords.columns.urls'),
        key: 'avgURLs',
        data: 'avgURLs',
        Component: Cell,
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;
            return collectCell(data, item.urlsL);
        },
    },
    {
        label: t('search.custom_keywords.columns.position'),
        key: 'avgPosition',
        data: 'avgPosition',
        Component: Cell,
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;
            return collectCell(data, item.positionL);
        },
    },
    {
        label: t('search.custom_keywords.columns.impressions'),
        key: 'impressions',
        data: 'impressions',
        Component: Cell,
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;
            return collectCell(data, item.impressionsL);
        },
    },
    {
        label: t('search.custom_keywords.columns.ctr'),
        key: 'avgCTR',
        data: 'avgCTR',
        Component: Cell,
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;
            return collectCell(data, item.ctrL, '0.00%');
        },
    },
];
